import {
    Modal, Box, Typography, IconButton, Button, Stack, SvgIcon,
} from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DynamicPillButton from "../buttonWithArrow/whatsappButton";
import CtaButton from "../buttonWithArrow";
import { lockScroll, unlockScroll } from "../../utils/scrollLock";
import { useEffect } from "react";

// ---------- styles ----------
const modalSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
};

const sheetSx = {
    position: "relative",
    width: 420,
    maxWidth: "92vw",
    bgcolor: "#fff",
    borderRadius: 4, // ~16px
    p: 3,
    boxShadow: "0 18px 60px rgba(0,0,0,.25)",
};

const titleSx = {
    fontWeight: 800,
    fontSize: 22,
    textAlign: "center",
    mb: 1,
};

const closeBtnSx = {
    position: "absolute",
    top: 8,
    right: 8,
    cursor: "pointer",
    // bgcolor: "#E7ECF1",
    // color: "#374151",
    // "&:hover": { bgcolor: "#E1E7EC" },
};

// gradient outline pill (selected)
const tileSelectedSx = {
    borderRadius: 3,
    height: 72,
    px: 2,
    textTransform: "none",
    fontWeight: 800,
    fontSize: 18,
    color: "#0D8196",
    border: "2px solid transparent",
    background:
        "linear-gradient(#fff,#fff) padding-box, linear-gradient(135deg,#81D0D5,#0D8196) border-box",
};

// disabled grey tile
const tileDisabledSx = {
    borderRadius: 3,
    height: 72,
    px: 2,
    textTransform: "none",
    fontWeight: 800,
    fontSize: 18,
    bgcolor: "#F4F5F6",
    border: "1px solid #E5E7EB",
    color: "#A3A7AD",
    "&.Mui-disabled": {
        bgcolor: "#F4F5F6",
        borderColor: "#E5E7EB",
        color: "#A3A7AD",
        opacity: 1, // keep text readable when disabled
    },
};


// ---------- component ----------
export default function EnquireModal({
    openEnquire,
    handleCloseEnquire,
    onPrivateJet,
    onWhatsapp,
    onOrderNow, setJetOption, jetOption, options, setActiveStep
}) {

    useEffect(() => {
        if (openEnquire) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [openEnquire]);

    return (
        <Modal open={openEnquire} onClose={handleCloseEnquire} sx={modalSx}>
            <Box sx={sheetSx}>
                <Typography
                    className="jura"
                    sx={{ ...titleSx, fontSize: 24, fontWeight: 800 }}
                >
                    Please Select An Option
                </Typography>


                <IconButton onClick={handleCloseEnquire} sx={closeBtnSx}>
                    <HighlightOffIcon />
                </IconButton>

                <Stack spacing={1.5} sx={{ mt: 2 }}>
                    {
                        options?.map((item, index) => (
                            <Button key={index} fullWidth
                                onClick={() => {
                                    if (setActiveStep) {
                                        setActiveStep(item?.activeStep);
                                    }
                                    setJetOption(item?.value);
                                }}
                                sx={item?.value === jetOption ? tileSelectedSx : tileDisabledSx}>
                                {item?.label}
                            </Button>
                        ))
                    }
                </Stack>

                <Stack
                    direction="row"
                    spacing={1.5}
                    justifyContent="center"
                    sx={{ mt: 2.5, flexDirection: { xs: "row", sm: "row" } }}
                >
                    <Box>
                        <DynamicPillButton
                            label="Send a message"
                            icon="/img/header/whatsapp.svg"
                            iconPosition="end"
                            bg="#25D366"
                            onClick={() => onWhatsapp(options?.filter(i => i.value === jetOption)?.[0]?.label)}
                            size="md"
                            sx={{ height: "100% !important", fontSize: { xs: "14px", sm: "auto" } }}
                        />
                    </Box>

                    <CtaButton label="Order now" onClick={onOrderNow} sx={{ fontSize: { xs: "14px", sm: "auto" } }} />
                </Stack>
            </Box>
        </Modal>
    );
}
